// ESCROW SERVICE DISABLED
// import { useState, useEffect } from 'react';
// import { escrowAPI } from '../services/api';
// import '../assets/css/escrow-settings-panel.css';

/* ORIGINAL ESCROW COMPONENT COMMENTED OUT:
const EscrowSettingsPanel = () => {
  const [emailNotifications, setEmailNotifications] = useState(true);
  const [pushNotifications, setPushNotifications] = useState(true);
  const [autoRelease, setAutoRelease] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleToggle = async (type, value) => {
    try {
      setLoading(true);
      setError(null);
      await escrowAPI.updateNotificationPreferences({ [type]: value });
    } catch (err) {
      setError('Failed to update settings');
      // Revert the toggle
      if (type === 'email') setEmailNotifications(!value);
      if (type === 'push') setPushNotifications(!value);
      if (type === 'autoRelease') setAutoRelease(!value);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="escrow-settings-panel">
      <h3 className="settings-title">
        <i className="fas fa-cog"></i>
        Escrow Preferences
      </h3>

      {error && (
        <div className="settings-error">
          <i className="fas fa-exclamation-circle"></i>
          {error}
        </div>
      )}

      <div className="settings-list">
        <div className="setting-item">
          <div className="setting-left">
            <i className="fas fa-envelope setting-icon"></i>
            <div className="setting-text">
              <div className="setting-label">Email Notifications</div>
              <div className="setting-description">Get updates via email</div>
            </div>
          </div>
          <label className="toggle-switch">
            <input
              type="checkbox"
              checked={emailNotifications}
              onChange={(e) => {
                setEmailNotifications(e.target.checked);
                handleToggle('email', e.target.checked);
              }}
              disabled={loading}
            />
            <span className="toggle-slider"></span>
          </label>
        </div>

        <div className="setting-item">
          <div className="setting-left">
            <i className="fas fa-bell setting-icon"></i>
            <div className="setting-text">
              <div className="setting-label">Push Notifications</div>
              <div className="setting-description">Real-time alerts</div>
            </div>
          </div>
          <label className="toggle-switch">
            <input
              type="checkbox"
              checked={pushNotifications}
              onChange={(e) => {
                setPushNotifications(e.target.checked);
                handleToggle('push', e.target.checked);
              }}
              disabled={loading}
            />
            <span className="toggle-slider"></span>
          </label>
        </div>

        <div className="setting-item">
          <div className="setting-left">
            <i className="fas fa-clock setting-icon"></i>
            <div className="setting-text">
              <div className="setting-label">Auto-Release (3 days)</div>
              <div className="setting-description">Automatic payment release after 3 days</div>
            </div>
          </div>
          <label className="toggle-switch">
            <input
              type="checkbox"
              checked={autoRelease}
              onChange={(e) => {
                setAutoRelease(e.target.checked);
                handleToggle('autoRelease', e.target.checked);
              }}
              disabled={loading}
            />
            <span className="toggle-slider"></span>
          </label>
        </div>
      </div>
    </div>
  );
};
*/

const EscrowSettingsPanel = () => null;

export default EscrowSettingsPanel;
